import classcat from "classcat";
import React from "react";

import { TextInput } from "@touchtech/web-baselayer-ui";

import { PhoneInput } from "@is/components/PhoneInput";
import { FieldState, FieldsValidation, SignUpInputFields } from "@is/types";

import css from "./SignUpFormField.module.css";
import useManageSignUpFormField from "./hooks/useManageSignUpFormField";

type Props = {
  field: FieldState;
  onChange: (name: string, type: string, value: string) => void;
  validation: FieldsValidation;
};

const PLACEHOLDER = {
  [SignUpInputFields.FirstName]: "Enter first name",
  [SignUpInputFields.LastName]: "Enter last name",
  [SignUpInputFields.PhoneNumber]: "Enter phone number",
  [SignUpInputFields.Email]: "Enter email address",
};

const SignUpFormField = ({ field, onChange, validation }: Props) => {
  const { type, handleTextInputChange, handlePhoneInputChange, t } =
    useManageSignUpFormField({ field, onChange });

  return (
    <div className={css.container}>
      {field.name === SignUpInputFields.PhoneNumber ? (
        <PhoneInput
          label={t(`${field.label}`)}
          width="full"
          error={validation[field.name]?.error}
          disabled={field.isDisabled}
          required={field.isRequired}
          value={field.value}
          onChange={handlePhoneInputChange}
        />
      ) : (
        <TextInput
          error={validation[field.name]?.error}
          placeholder={t(`${PLACEHOLDER[field.name]}`)}
          value={field.value}
          name={field.name}
          label={t(`${field.label}`)}
          width="full"
          required={field.isRequired}
          onChange={handleTextInputChange}
          autoComplete="new-password"
          autoCapitalize="sentences"
          type={type}
        />
      )}
      {validation[field.name].message && (
        <div className={classcat(["text-label-base", css.errorMessage])}>
          {validation[field.name].message}
        </div>
      )}
    </div>
  );
};

export default SignUpFormField;
